import { usePruebaContext } from "../../Hooks/Prueba/usepruebacontext"
import { theme, Typography, Table } from "antd";
const { useToken } = theme;

function formatoValor(v) {
    if (v === null || v === undefined || v === "") return "";
    const n = Number(v);
    if (Number.isFinite(n)) return n.toFixed(2);
    return String(v);
}

export function TableParamsPrueba({ newparametros, muestra_seleccionada }) {
    const { pruebaActiva, pruebas } = usePruebaContext()
    const prueba = pruebaActiva ?? pruebas[0]
    const { token } = useToken()

    let dataSource =
        Array.isArray(newparametros) && newparametros.length > 0
            ? [...newparametros]
            : [...(prueba?.parametros ?? [])]

    // Las pruebas COP agrupan sus métricas por categoría (Fuerza/COP).
    const muestraCategoria = dataSource.some((p) => p?.categoria);

    if (muestra_seleccionada) {
        dataSource = dataSource.map((p, i) => {
            const refM = muestra_seleccionada?.parametros?.[i]
            if (refM) {
                return {
                    ...p,
                    media: refM.valor,
                    porcentaje: (Number(p.valor) / Number(refM.valor) - 1) * 100,
                    dif: Number(p.valor) - Number(refM.valor),
                }
            }
            return { ...p }
        })
    }

    return (
        <div style={{ width: "100%", maxWidth: "100%", minWidth: 0, overflow: "hidden" }}>
            <Table
                rowKey={(row, index) => `${row?.nombre ?? "p"}-${index}`}
                dataSource={dataSource}
                pagination={false}
                size="small"
                tableLayout="fixed"
                scroll={{ x: 720, y: 480 }}
                style={{ width: "100%" }}
            >
                {muestraCategoria ? (
                    <Table.Column title="Categoría" dataIndex="categoria" width={120} />
                ) : null}
                <Table.Column title="Parámetro" dataIndex="nombre" ellipsis width={280} />
                <Table.Column
                    title="Valor"
                    dataIndex="valor"
                    width={200}
                    render={(v, record) => (
                        <Typography.Text style={{ margin: 0, color: token.colorPrimary, wordBreak: "break-word" }}>
                            {formatoValor(v)}
                            {record.u ? ` ${record.u}` : ""}
                        </Typography.Text>
                    )}
                />
                {muestra_seleccionada ? (
                    <>
                        <Table.Column
                            title="Muestra"
                            dataIndex="media"
                            width={120}
                            render={(v) => (v !== null && v !== undefined && v !== "" ? formatoValor(v) : "")}
                        />
                        <Table.Column
                            title="% diferencia"
                            dataIndex="porcentaje"
                            width={120}
                            render={(v) => (Number.isFinite(Number(v)) ? `${Number(v).toFixed(2)}%` : "")}
                        />
                        <Table.Column
                            title="Dif total"
                            dataIndex="dif"
                            width={120}
                            render={(v) => (v !== null && v !== undefined && v !== "" ? formatoValor(v) : "")}
                        />
                    </>
                ) : null}
            </Table>
        </div>
    )
}